import { useMemo } from "react";
import { WorksheetItemInput } from "DDD/action-objects/WorksheetItemUpdate";
import { HelperResolution } from "utils/worksheet/worksheetHelpers";
import { calculateEstimatedMargin, calculateLineTotal } from "utils/worksheet/worksheetMath";
import {
  dollarsToCents,
  getDirectCosts,
  getEnteredCosts,
  parseDecimalInput,
} from "./worksheetFormValues";

export type WorksheetTotals = ReturnType<typeof useWorksheetTotals>;

export default function useWorksheetTotals(
  values: WorksheetItemInput,
  resolution: HelperResolution
) {
  return useMemo(() => {
    const total = calculateLineTotal({
      pricingMode: values.pricingMode,
      sellingQuantity: parseDecimalInput(values.sellingQuantity),
      sellingRate: dollarsToCents(values.sellingRate),
      fixedTotal: dollarsToCents(values.fixedTotal),
      directCosts: getDirectCosts(values, resolution),
      overheadPercentage: parseDecimalInput(values.overheadPercentage),
      indirectPercentage: parseDecimalInput(values.indirectPercentage),
      markupPercentage: parseDecimalInput(values.markupPercentage),
    });
    const enteredCosts = getEnteredCosts(values, resolution);
    const costCents = enteredCosts ?? 0;
    const profitCents = total - costCents;
    const marginPercentage = calculateEstimatedMargin(total, enteredCosts);

    return { total, enteredCosts, costCents, profitCents, marginPercentage };
  }, [values, resolution]);
}
